﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customEventThemeColorEditItem from './tpl/customEventThemeColorEdititem.html';
import language from '../../../common/language';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';
import * as Entities_Memory from '../../entities/memory';
import * as Entities_Memory_PositionPageable from '../../entities/memoryPositionPageable';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_CustomHeader from '../region/customHeader/customHeader';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import helper_infopage from '../../helper/infopage';

import config from '../../../common/config';
import Help from '../../helper/help';
import helper_event from '../../../event/helper/event';

import View_Render from '../render/render';

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_customEventThemeColorEditItem();
    },
    regions: {
        customHeader: "#customHeader",
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        this.save(callback);
    },
    cancelHasChanged: function () {
        this.model.attributes = this.oldModel.attributes;
    },
    modelHasChanged: function () {
        var changes = false;

        if (this.model) {
            //this.setModel();

            //RememberFinish
            if ((this.model.attributes.BackGroundColor != this.oldModel.attributes.BackGroundColor) ||
                (this.model.attributes.BackGroundColorApp != this.oldModel.attributes.BackGroundColorApp) ||
                (this.model.attributes.MenuColorApp_BackGround != this.oldModel.attributes.MenuColorApp_BackGround) ||
                (this.model.attributes.MenuColor_BackGround != this.oldModel.attributes.MenuColor_BackGround) ||
                (this.model.attributes.MenuColorApp_ForeGround != this.oldModel.attributes.MenuColorApp_ForeGround) ||
                (this.model.attributes.MenuColor_ForeGround != this.oldModel.attributes.MenuColor_ForeGround) ||
                (this.model.attributes.MenuColorApp_Font != this.oldModel.attributes.MenuColorApp_Font) ||
                (this.model.attributes.MenuColorApp_FontSize_Header01 != this.oldModel.attributes.MenuColorApp_FontSize_Header01) ||
                (this.model.attributes.MenuColorApp_FontSize_Header02 != this.oldModel.attributes.MenuColorApp_FontSize_Header02) ||
                (this.model.attributes.MenuColorApp_FontSize_Footer != this.oldModel.attributes.MenuColorApp_FontSize_Footer) ||
                (this.model.attributes.Font1 != this.oldModel.attributes.Font1) ||
                (this.model.attributes.Font1_Color != this.oldModel.attributes.Font1_Color) ||
                (this.model.attributes.Font1_Size != this.oldModel.attributes.Font1_Size) ||
                (this.model.attributes.Font1_Style != this.oldModel.attributes.Font1_Style) ||
                (this.model.attributes.Font1_LineHeight != this.oldModel.attributes.Font1_LineHeight) ||
                (this.model.attributes.Font2 != this.oldModel.attributes.Font2) ||
                (this.model.attributes.Font2_Color != this.oldModel.attributes.Font2_Color) ||
                (this.model.attributes.Font2_Size != this.oldModel.attributes.Font2_Size) ||
                (this.model.attributes.Font2_Style != this.oldModel.attributes.Font2_Style) ||
                (this.model.attributes.Font2_LineHeight != this.oldModel.attributes.Font2_LineHeight)) {
                changes = true;
            }
        }

        this.setHasChanged(changes);
    },
    save: function (callbackRouter) {
        var self = this;

        var dialogWaitingModel = new Entities_Empty.Model();
        dialogWaitingModel.attributes.Title = resources.X101538;
        dialogWaitingModel.attributes.Text = resources.X100409;
        dialogWaitingModel.attributes.Button = resources.X100279;

        var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
        var callback = function (options) {
            self.stopListening(dialogWaiting, "dialog:okclicked", callback);
        }
        this.listenTo(dialogWaiting, "dialog:okclicked", callback);
        this.app.dialogRegion.show(dialogWaiting);

        //this.setModel();

        var customModule = self.app.entities.collections.customModule.where({ EventId: this.options.eventId, ModuleType: 98 })[0];
        var data = JSON.parse(customModule.attributes.Data);
        var customModule_data = new Entities_Memory.Model(data[0].Data);
        var tmpCollection = new Entities_Memory_PositionPageable.Collection(data[0].Data.ThemeCollection);

        var model = tmpCollection.where({ id: this.model.attributes.id })[0];

        model.attributes = this.model.attributes;

        customModule_data.attributes.ThemeCollection = tmpCollection.toJSON();
        var strJson = JSON.stringify(customModule_data.toJSON());
        customModule.attributes.Data = '[{ "Data" : ' + strJson + '}]';

        customModule.save(customModule.attribute, {
            silent: false,
            wait: true,
            success: function () {
                //Update all using template
                helper_infopage.updateFontFromTheme(self.options.eventId, self.app);

                dialogWaiting.triggerMethod('dialog:close');
                self.oldModel = self.model.clone();
                callbackRouter();

                var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: self.options.eventId });
                var render = new View_Render({ collection: customEvent, app: self.app });
                self.app.renderRegion.show(render);
                var renderFinishCallback = function (options) {
                }
                render.doIt(renderFinishCallback, true, 'EVENT_REFRESH', false);



                //var render = new View_Render({ collection: customEvent, app: self.app });
                //self.app.renderRegion.show(render);
                //var renderFinishCallback = function (options) {
                //    if (callbackRouter) {
                //        callbackRouter();
                //    }
                //}
                //render.doIt(renderFinishCallback, false, 'EVENT_REFRESH', false);
            }
        });
    },
    onBeforeShow: function () {
        //this.information.show(new View_Information({ collection: this.informationCollection, app: this.app }));

        var customHeaderModel = new Entities_Empty.Model();

        var customEvent = this.app.entities.collections.customEvent.fullCollection.where({ id: this.options.eventId });
        if (customEvent.length > 0) {
            customHeaderModel.attributes.Name = customEvent[0].attributes.Name;
        } else {
            customHeaderModel.attributes.Name = "";
        }

        switch (this.model.attributes.Standard) {
            case 2: customHeaderModel.attributes.Title = resources.X101538;
                customHeaderModel.attributes.ShowSave = true;
                break;
            case 0: customHeaderModel.attributes.Title = resources.X101539;
                customHeaderModel.attributes.ShowSave = false;
                break;
        }

        customHeaderModel.attributes.ShowBack = true;

        this.customHeader.show(new View_CustomHeader({ app: this.app, model: customHeaderModel }));
    },
    initialize: function () {
        this.app = this.options.app;

        var userChannel = Backbone.Radio.channel('app');
        var self = this;

        this.listenTo(userChannel, 'customHeader:iconSave', function () {
            self.customEventThemeColorEditItem_btnSave_click();
        });
        this.listenTo(userChannel, 'customHeader:iconBack', function () {
            self.customEventThemeColorEditItem_btnBack_click();
        });	

        this.setHasChanged(false);
        this.oldModel = this.model.clone();

        //var tmpSelectedModelSetting = this.app.entities.collections.customModule.where({ EventId: this.options.localSetting.attributes.EventId, ModuleType: 98 })[0];
        //var data = JSON.parse(tmpSelectedModelSetting.attributes.Data);
        //this.model = new Entities_Memory.Model(data[0].Data);

        //helper_event.setupCssStyle2(this);
    },
    ui: {
        'customEventThemeColorEditItem_ColorPickerSliders_MenuColorApp_BackGround': '#customEventThemeColorEditItem_ColorPickerSliders_MenuColorApp_BackGround',
        'customEventThemeColorEditItem_ColorPickerSliders_MenuColorApp_ForeGround': '#customEventThemeColorEditItem_ColorPickerSliders_MenuColorApp_ForeGround',
        'customEventThemeColorEditItem_ColorPickerSliders_BackGroundColorApp': '#customEventThemeColorEditItem_ColorPickerSliders_BackGroundColorApp',
        'customEventThemeColorEditItem_ColorPickerSliders_Font1_Color': '#customEventThemeColorEditItem_ColorPickerSliders_Font1_Color',
        'customEventThemeColorEditItem_ColorPickerSliders_Font2_Color': '#customEventThemeColorEditItem_ColorPickerSliders_Font2_Color',
        'customEventThemeColorEditItem_dropDown_MenuColorApp_Font': '#customEventThemeColorEditItem_dropDown_MenuColorApp_Font',
        'customEventThemeColorEditItem_dropDown_Font1': '#customEventThemeColorEditItem_dropDown_Font1',
        'customEventThemeColorEditItem_dropDown_Font2': '#customEventThemeColorEditItem_dropDown_Font2',
        'customEventThemeColorEditItem_formgroup_MenuColorApp_Font': '#customEventThemeColorEditItem_formgroup_MenuColorApp_Font',
        'customEventThemeColorEditItem_formgroup_Font1': '#customEventThemeColorEditItem_formgroup_Font1',
        'customEventThemeColorEditItem_formgroup_Font2': '#customEventThemeColorEditItem_formgroup_Font2',
        'customEventThemeColorEditItem_ColorPickerSliders_AppFrame_BackGroundColor': '#customEventThemeColorEditItem_ColorPickerSliders_AppFrame_BackGroundColor',
        'customEventThemeColorEditItem_ColorPickerSliders_AppFrame_ForeGroundColor': '#customEventThemeColorEditItem_ColorPickerSliders_AppFrame_ForeGroundColor',
        'customEventThemeColorEditItem_ColorPickerSliders_Info_BackGroundColor': '#customEventThemeColorEditItem_ColorPickerSliders_Info_BackGroundColor',
        'customEventThemeColorEditItem_ColorPickerSliders_Info_ForeGroundColor': '#customEventThemeColorEditItem_ColorPickerSliders_Info_ForeGroundColor',
        'customEventThemeColorEditItem_ColorPickerSliders_Info_Font1_Color': '#customEventThemeColorEditItem_ColorPickerSliders_Info_Font1_Color',
        'customEventThemeColorEditItem_dropDown_Info_Font1': '#customEventThemeColorEditItem_dropDown_Info_Font1',
        'customEventThemeColorEditItem_formgroup_Info_Font1': '#customEventThemeColorEditItem_formgroup_Info_Font1',
        'customEventThemeColorEditItem_ColorPickerSliders_Info_Font2_Color': '#customEventThemeColorEditItem_ColorPickerSliders_Info_Font2_Color',
        'customEventThemeColorEditItem_dropDown_Info_Font2': '#customEventThemeColorEditItem_dropDown_Info_Font2',
        'customEventThemeColorEditItem_formgroup_Info_Font2': '#customEventThemeColorEditItem_formgroup_Info_Font2',
        'customEventThemeColorEditItem_ColorPickerSliders_Info_Font3_Color': '#customEventThemeColorEditItem_ColorPickerSliders_Info_Font3_Color',
        'customEventThemeColorEditItem_dropDown_Info_Font3': '#customEventThemeColorEditItem_dropDown_Info_Font3',
        'customEventThemeColorEditItem_formgroup_Info_Font3': '#customEventThemeColorEditItem_formgroup_Info_Font3',
        'customEventThemeColorEditItem_ColorPickerSliders_Info_Font4_Color': '#customEventThemeColorEditItem_ColorPickerSliders_Info_Font4_Color',
        'customEventThemeColorEditItem_dropDown_Info_Font4': '#customEventThemeColorEditItem_dropDown_Info_Font4',
        'customEventThemeColorEditItem_formgroup_Info_Font4': '#customEventThemeColorEditItem_formgroup_Info_Font4',

        'e4us_maincolor_01': '#e4us_maincolor_01',
        'e4us_maincolor_02': '#e4us_maincolor_02',
        'e4us_maincolor_03': '#e4us_maincolor_03',
        'e4us_navbar_toggler_01': '#e4us_navbar_toggler_01',
        'e4us_navbar_toggler_icon': '#e4us_navbar_toggler_icon',
        'e4us_menucolor02_01': '#e4us_menucolor02_01',
        'e4us_menucolor02_02': '#e4us_menucolor02_02',
        'e4us_menucolor02_03': '#e4us_menucolor02_03',
        'e4us_menucolor02_04': '#e4us_menucolor02_04',
        'e4us_menucolor02_05': '#e4us_menucolor02_05',
        'e4us_menucolor01_01': '#e4us_menucolor01_01',
        'e4us_menucolor01_02': '#e4us_menucolor01_02',
        'e4us_menucolor01_03': '#e4us_menucolor01_03',
        'e4us_menucolor01_04': '#e4us_menucolor01_04',
        'e4us_menucolor01_05': '#e4us_menucolor01_05',
        'e4us_menucolor01_06': '#e4us_menucolor01_06',
        'e4us_menucolor01_07': '#e4us_menucolor01_07',
        'e4us_menucolor01_08': '#e4us_menucolor01_08',
        'e4us_backgroundcolor_01': '#e4us_backgroundcolor_01',
        'e4us_backgroundcolor_02': '#e4us_backgroundcolor_02',
        'windowMenu_icon01': '#windowMenu_icon01',
        'windowMenu_icon02': '#windowMenu_icon02',
        'windowMenu_icon03': '#windowMenu_icon03',
        'windowMenu_icon04': '#windowMenu_icon04',
        'windowMenu_icon05': '#windowMenu_icon05',
        'windowMenu_icon06': '#windowMenu_icon06',
        'windowMenu_icon07': '#windowMenu_icon07',
        'windowMenu_icon08': '#windowMenu_icon08',
        'windowMenu_icon09': '#windowMenu_icon09',
        'windowMenu_icon10': '#windowMenu_icon10',
        'windowMenu_icon11': '#windowMenu_icon11',
        'windowMenu_icon12': '#windowMenu_icon12',
        'windowMenu_a01': '#windowMenu_a01',
        'windowMenu_a02': '#windowMenu_a02',
        'windowMenu_a03': '#windowMenu_a03',
        'windowMenu_a04': '#windowMenu_a04',
        'windowMenu_a05': '#windowMenu_a05',
        'windowMenu_a06': '#windowMenu_a06',
        'windowMenu_a07': '#windowMenu_a07',
        'windowMenu_a08': '#windowMenu_a08',
        'windowMenu_a09': '#windowMenu_a09',
        'windowMenu_a10': '#windowMenu_a10',
        'windowMenu_a11': '#windowMenu_a11',
        'windowMenu_a12': '#windowMenu_a12',
        'windowMenu_div': '#windowMenu_div',
        'region001_1': '#region001_1',
        'region001_2': '#region001_2',
        'region001_3': '#region001_3',
        'hfont_01': '#hfont_01',
        'hfont_02': '#hfont_02',
        'hfont_03': '#hfont_03',
        'hfont_04': '#hfont_04',
        'pfont_01': '#pfont_01',
        'pfont_02': '#pfont_02',


        //'customEventThemeColorInsert_btnPushSubmit': '#customEventThemeColorInsert_btnPushSubmit',
        //'customEventThemeColorInsert_inputPush': '#customEventThemeColorInsert_inputPush',
        //'customEventThemeColorInsert_badge' : '#customEventThemeColorInsert_badge'
    },
    events: {
        //'click @ui.customEventThemeColorInsert_btnPushSubmit': 'btnPushSubmit'
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_MenuColorApp_BackGround': 'colorChange_MenuColorApp_BackGround',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_MenuColorApp_ForeGround': 'colorChange_MenuColorApp_ForeGround',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_BackGroundColorApp': 'colorChange_BackGroundColorApp',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_Font1_Color': 'colorChange_Font1_Color',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_Font2_Color': 'colorChange_Font2_Color',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_AppFrame_BackGroundColor': 'colorChange_AppFrame_BackGroundColor',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_AppFrame_ForeGroundColor': 'colorChange_AppFrame_ForeGroundColor',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_Info_BackGroundColor': 'colorChange_Info_BackGroundColor',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_Info_ForeGroundColor': 'colorChange_Info_ForeGroundColor',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font1_Color': 'colorChange_Info_Font1_Color',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font2_Color': 'colorChange_Info_Font2_Color',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font3_Color': 'colorChange_Info_Font3_Color',
        'colorpickerChange @ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font4_Color': 'colorChange_Info_Font4_Color',
    },
    colorChange_MenuColorApp_BackGround: function (e) {
        this.model.attributes.MenuColorApp_BackGround = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_MenuColorApp_ForeGround: function (e) {
        this.model.attributes.MenuColorApp_ForeGround = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_BackGroundColorApp: function (e) {
        this.model.attributes.BackGroundColorApp = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_Font1_Color: function (e) {
        this.model.attributes.Font1_Color = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_Font2_Color: function (e) {
        this.model.attributes.Font2_Color = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_AppFrame_BackGroundColor: function (e) {
        this.model.attributes.AppFrame_BackGroundColor = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_AppFrame_ForeGroundColor: function (e) {
        this.model.attributes.AppFrame_ForeGroundColor = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_Info_BackGroundColor: function (e) {
        this.model.attributes.Info_BackGroundColor = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_Info_ForeGroundColor: function (e) {
        this.model.attributes.Info_ForeGroundColor = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_Info_Font1_Color: function (e) {
        this.model.attributes.Info_Font1_Color = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_Info_Font2_Color: function (e) {
        this.model.attributes.Info_Font2_Color = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_Info_Font3_Color: function (e) {
        this.model.attributes.Info_Font3_Color = e.value.toRgbString();
        this.updateAll();
    },
    colorChange_Info_Font4_Color: function (e) {
        this.model.attributes.Info_Font4_Color = e.value.toRgbString();
        this.updateAll();
    },
    onRender: function () {

        this.setupCss();

        return this;
    },
    onAttach() {
        var self = this;

        var fonts = [];

        self.app.entities.collections.Font.forEach(function (entry) {
            fonts.push(entry.attributes.data_font_family);
        });

        var images = [];

        self.app.entities.collections.Font.forEach(function (entry) {
            images.push(entry.attributes.image);
        });

        this.ui.customEventThemeColorEditItem_dropDown_MenuColorApp_Font.fontselect({
            googleFonts: fonts,
            images: images
        }).on('change', function () {
            self.model.attributes.MenuColorApp_Font = this.value;
            self.updateAll();
        });
        this.ui.customEventThemeColorEditItem_dropDown_MenuColorApp_Font.trigger('setFont', self.model.attributes.MenuColorApp_Font);

        this.ui.customEventThemeColorEditItem_dropDown_Font1.fontselect({
            googleFonts: fonts,
            images: images
        }).on('change', function () {
            self.model.attributes.Font1 = this.value;
            self.updateAll();
        });
        this.ui.customEventThemeColorEditItem_dropDown_Font1.trigger('setFont', self.model.attributes.Font1);

        this.ui.customEventThemeColorEditItem_dropDown_Font2.fontselect({
            googleFonts: fonts,
            images: images
        }).on('change', function () {
            self.model.attributes.Font2 = this.value;
            self.updateAll();
        });
        this.ui.customEventThemeColorEditItem_dropDown_Font2.trigger('setFont', self.model.attributes.Font2);

        this.ui.customEventThemeColorEditItem_ColorPickerSliders_MenuColorApp_BackGround.colorpicker({
            color: self.model.attributes.MenuColorApp_BackGround,
            format: "rgb"
        });

        this.ui.customEventThemeColorEditItem_ColorPickerSliders_MenuColorApp_ForeGround.colorpicker({
            color: self.model.attributes.MenuColorApp_ForeGround,
            format: "rgb"
        });

        this.ui.customEventThemeColorEditItem_ColorPickerSliders_BackGroundColorApp.colorpicker({
            color: self.model.attributes.BackGroundColorApp,
            format: "rgb"
        });

        this.ui.customEventThemeColorEditItem_ColorPickerSliders_Font1_Color.colorpicker({
            color: self.model.attributes.Font1_Color,
            format: "rgb"
        });

        this.ui.customEventThemeColorEditItem_ColorPickerSliders_Font2_Color.colorpicker({
            color: self.model.attributes.Font2_Color,
            format: "rgb"
        });

        if (this.model.attributes.Standard == 0) {
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_MenuColorApp_BackGround.colorpicker('colorpicker');
            cp.disable();
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_MenuColorApp_ForeGround.colorpicker('colorpicker');
            cp.disable();
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_BackGroundColorApp.colorpicker('colorpicker');
            cp.disable();
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_Font1_Color.colorpicker('colorpicker');
            cp.disable();
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_Font2_Color.colorpicker('colorpicker');
            cp.disable();

            this.ui.customEventThemeColorEditItem_formgroup_MenuColorApp_Font.addClass('disabledFontSelect_FormGroup');
            this.ui.customEventThemeColorEditItem_formgroup_MenuColorApp_Font.find('.font-select').addClass('disabledFontSelect_FontSelect');
            this.ui.customEventThemeColorEditItem_formgroup_Font1.addClass('disabledFontSelect_FormGroup');
            this.ui.customEventThemeColorEditItem_formgroup_Font1.find('.font-select').addClass('disabledFontSelect_FontSelect');
            this.ui.customEventThemeColorEditItem_formgroup_Font2.addClass('disabledFontSelect_FormGroup');
            this.ui.customEventThemeColorEditItem_formgroup_Font2.find('.font-select').addClass('disabledFontSelect_FontSelect');
        }

        this.ui.customEventThemeColorEditItem_ColorPickerSliders_AppFrame_BackGroundColor.colorpicker({
            color: self.model.attributes.AppFrame_BackGroundColor,
            format: "rgb"
        });
        this.ui.customEventThemeColorEditItem_ColorPickerSliders_AppFrame_ForeGroundColor.colorpicker({
            color: self.model.attributes.AppFrame_ForeGroundColor,
            format: "rgb"
        });
        this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_BackGroundColor.colorpicker({
            color: self.model.attributes.Info_BackGroundColor,
            format: "rgb"
        });
        this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_ForeGroundColor.colorpicker({
            color: self.model.attributes.Info_ForeGroundColor,
            format: "rgb"
        });

        this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font1_Color.colorpicker({
            color: self.model.attributes.Info_Font1_Color,
            format: "rgb"
        });

        this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font2_Color.colorpicker({
            color: self.model.attributes.Info_Font2_Color,
            format: "rgb"
        });

        this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font3_Color.colorpicker({
            color: self.model.attributes.Info_Font3_Color,
            format: "rgb"
        });


        this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font4_Color.colorpicker({
            color: self.model.attributes.Info_Font4_Color,
            format: "rgb"
        });

        this.ui.customEventThemeColorEditItem_dropDown_Info_Font1.fontselect({
            googleFonts: fonts,
            images: images
        }).on('change', function () {
            self.model.attributes.Info_Font1 = this.value;
            self.updateAll();
        });
        this.ui.customEventThemeColorEditItem_dropDown_Info_Font1.trigger('setFont', self.model.attributes.Info_Font1);

        this.ui.customEventThemeColorEditItem_dropDown_Info_Font2.fontselect({
            googleFonts: fonts,
            images: images
        }).on('change', function () {
            self.model.attributes.Info_Font2 = this.value;
            self.updateAll();
        });
        this.ui.customEventThemeColorEditItem_dropDown_Info_Font2.trigger('setFont', self.model.attributes.Info_Font2);

        this.ui.customEventThemeColorEditItem_dropDown_Info_Font3.fontselect({
            googleFonts: fonts,
            images: images
        }).on('change', function () {
            self.model.attributes.Info_Font3 = this.value;
            self.updateAll();
        });
        this.ui.customEventThemeColorEditItem_dropDown_Info_Font3.trigger('setFont', self.model.attributes.Info_Font3);

        this.ui.customEventThemeColorEditItem_dropDown_Info_Font4.fontselect({
            googleFonts: fonts,
            images: images
        }).on('change', function () {
            self.model.attributes.Info_Font4 = this.value;
            self.updateAll();
        });
        this.ui.customEventThemeColorEditItem_dropDown_Info_Font4.trigger('setFont', self.model.attributes.Info_Font4);

        if (this.model.attributes.Standard == 0) {
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_AppFrame_BackGroundColor.colorpicker('colorpicker');
            cp.disable();
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_AppFrame_ForeGroundColor.colorpicker('colorpicker');
            cp.disable();
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_BackGroundColor.colorpicker('colorpicker');
            cp.disable();
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_ForeGroundColor.colorpicker('colorpicker');
            cp.disable();

            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font1_Color.colorpicker('colorpicker');
            cp.disable();
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font2_Color.colorpicker('colorpicker');
            cp.disable();
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font3_Color.colorpicker('colorpicker');
            cp.disable();
            var cp = this.ui.customEventThemeColorEditItem_ColorPickerSliders_Info_Font4_Color.colorpicker('colorpicker');
            cp.disable();

            this.ui.customEventThemeColorEditItem_formgroup_Info_Font1.addClass('disabledFontSelect_FormGroup');
            this.ui.customEventThemeColorEditItem_formgroup_Info_Font1.find('.font-select').addClass('disabledFontSelect_FontSelect');
            this.ui.customEventThemeColorEditItem_formgroup_Info_Font2.addClass('disabledFontSelect_FormGroup');
            this.ui.customEventThemeColorEditItem_formgroup_Info_Font2.find('.font-select').addClass('disabledFontSelect_FontSelect');
            this.ui.customEventThemeColorEditItem_formgroup_Info_Font3.addClass('disabledFontSelect_FormGroup');
            this.ui.customEventThemeColorEditItem_formgroup_Info_Font3.find('.font-select').addClass('disabledFontSelect_FontSelect');
            this.ui.customEventThemeColorEditItem_formgroup_Info_Font4.addClass('disabledFontSelect_FormGroup');
            this.ui.customEventThemeColorEditItem_formgroup_Info_Font4.find('.font-select').addClass('disabledFontSelect_FontSelect');

        }
    },
    updateAll: function () {
        this.setupCss();
    },
    hexc: function (colorval) {
        var parts = colorval.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        delete (parts[0]);
        for (var i = 1; i <= 3; ++i) {
            parts[i] = parseInt(parts[i]).toString(16);
            if (parts[i].length == 1) parts[i] = '0' + parts[i];
        }
        return '#' + parts.join('');
    },
    colorLuminance: function (hex, lum) {
        // validate hex string
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        lum = lum || 0;

        // convert to decimal and change luminosity
        var rgb = "#", c, i;
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += ("00" + c).substr(c.length);
        }

        return rgb;
    },
    trim: function (str) {
        return str.replace(/^\s+|\s+$/gm, '');
    },
    rgba2rgb: function (/*rgb,*/ rgba) {
        var inParts = rgba.substring(rgba.indexOf("(")).split(","),
            r = parseInt(this.trim(inParts[0].substring(1)), 10),
            g = parseInt(this.trim(inParts[1]), 10),
            b = parseInt(this.trim(inParts[2]), 10),
            a = parseFloat(this.trim(inParts[3].substring(0, inParts[3].length - 1))).toFixed(2);
        var outParts = [
            r,
            g,
            b
        ];

        // Pad single-digit output values


        return outParts;
    },
    rgb2rgb: function (/*rgb,*/ rgb) {
        var inParts = rgb.substring(rgb.indexOf("(")).split(","),
            r = parseInt(this.trim(inParts[0].substring(1)), 10),
            g = parseInt(this.trim(inParts[1]), 10),
            b = parseInt(this.trim(inParts[2]), 10)
        var outParts = [
            r,
            g,
            b
        ];

        // Pad single-digit output values


        return outParts;
    },
    rgb2hex: function (/*rgb,*/ rgba) {
        var inParts = rgba.substring(rgba.indexOf("(")).split(","),
            r = parseInt(this.trim(inParts[0].substring(1)), 10),
            g = parseInt(this.trim(inParts[1]), 10),
            b = parseInt(this.trim(inParts[2]), 10),
            a = parseFloat(this.trim(inParts[3].substring(0, inParts[3].length - 1))).toFixed(2);
        var outParts = [
            r.toString(16),
            g.toString(16),
            b.toString(16)//,
            //Math.round(a * 255).toString(16).substring(0, 2)
        ];

        // Pad single-digit output values
        outParts.forEach(function (part, i) {
            if (part.length === 1) {
                outParts[i] = '0' + part;
            }
        })

        return ('#' + outParts.join(''));
    },
    setupCss: function () {
        var MenuColorApp_BackGround = 'rgba(50,115,32,1)';
        //var BackGroundColorApp = 'rgba(221,221,221,1)'; grey make all white more easy
        var BackGroundColorApp = 'rgba(255,255,255,1)';
        var MenuColorApp_ForeGround = 'rgba(0,0,0,1)';

        //var MenuColorApp_Font = 'Roboto,sans-serif';
        var MenuColorApp_Font = 'Open Sans';
        //var MenuColorApp_Font = 'Abril Fatface';

        var MenuColorApp_FontSize_Header01 = '20px';
        var MenuColorApp_FontSize_Header02 = '16px';
        var MenuColorApp_FontSize_Footer = '12px';

        var Font1 = 'Open Sans';
        var Font1_Color = 'rgb(0, 0, 0)';
        var Font1_Size = '50px';
        var Font2 = 'Open Sans';
        var Font2_Color = 'rgb(0, 0, 0)';
        var Font2_Size = '40px';

        //var MenuColorApp_BackGround = 'rgba(38,173,228,1)';
        //var BackGroundColorApp = 'rgba(255,255,255,1)';
        //var MenuColorApp_ForeGround = 'rgba(0,0,0,1)';
        //var Font1 = 'Abril Fatface';
        //var Font1_Color = 'rgb(0, 0, 0)';
        //var Font2 = 'Abril Fatface';
        //var Font2_Color = 'rgb(0, 0, 0)';

        //var MenuColorApp_BackGround = 'rgba(255,0,0,1)';
        //var BackGroundColorApp = 'rgba(255,255,255,1)';
        //var MenuColorApp_ForeGround = 'rgba(0,0,0,1)';
        //var Font1 = 'Abril Fatface';
        //var Font1_Color = 'rgb(0, 0, 0)';
        //var Font2 = 'Abril Fatface';
        //var Font2_Color = 'rgb(0, 0, 0)';

        //var rgb = this.rgba2rgb(this.model.attributes.MenuColorApp_ForeGround);
        var rgb = this.rgb2rgb(this.model.attributes.MenuColorApp_ForeGround);
        this.model.attributes.MenuColorApp_ForeGround02 = String.format('rgba({0},{1},{2},0.9', rgb[0], rgb[1], rgb[2]);
        this.model.attributes.MenuColorApp_ForeGround03 = String.format('rgba({0},{1},{2},0.7', rgb[0], rgb[1], rgb[2]);

        this.ui.e4us_maincolor_01.css('background-color', this.model.attributes.MenuColorApp_BackGround);
        this.ui.e4us_maincolor_02.css('background-color', this.model.attributes.MenuColorApp_BackGround);
        this.ui.e4us_maincolor_02.css('color', this.model.attributes.MenuColorApp_ForeGround);


        this.ui.e4us_maincolor_03.css('background-color', this.model.attributes.BackGroundColorApp);

        this.ui.e4us_backgroundcolor_01.css('background-color', this.model.attributes.BackGroundColorApp);
        this.ui.e4us_backgroundcolor_02.css('background-color', this.model.attributes.BackGroundColorApp);

        this.ui.e4us_navbar_toggler_01.css('border-color', this.model.attributes.MenuColorApp_ForeGround);
        var s = String.format("data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='{0}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e", this.model.attributes.MenuColorApp_ForeGround);
        this.ui.e4us_navbar_toggler_icon.css('background-image', String.format('url("{0}"', s));
        this.ui.e4us_menucolor02_01.css('color', this.model.attributes.MenuColorApp_ForeGround03);
        this.ui.e4us_menucolor02_02.css('color', this.model.attributes.MenuColorApp_ForeGround03);
        this.ui.e4us_menucolor02_03.css('color', this.model.attributes.MenuColorApp_ForeGround03);
        this.ui.e4us_menucolor02_04.css('color', this.model.attributes.MenuColorApp_ForeGround03);
        this.ui.e4us_menucolor02_05.css('color', this.model.attributes.MenuColorApp_ForeGround03);
        this.ui.e4us_menucolor01_01.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_02.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_03.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_04.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_05.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_06.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_07.css('color', this.model.attributes.MenuColorApp_ForeGround02);
        this.ui.e4us_menucolor01_08.css('color', this.model.attributes.MenuColorApp_ForeGround02);

        this.ui.windowMenu_icon01.css('color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_icon02.css('color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_icon03.css('color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_icon04.css('color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_icon05.css('color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_icon06.css('color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_icon07.css('color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_icon08.css('color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_icon09.css('color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_icon10.css('color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_icon11.css('color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_icon12.css('color', this.model.attributes.AppFrame_ForeGroundColor);

        this.ui.windowMenu_a01.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_a02.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_a03.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_a04.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_a05.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_a06.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_a07.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_a08.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_a09.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_a10.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_a11.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);
        this.ui.windowMenu_a12.css('border-color', this.model.attributes.AppFrame_ForeGroundColor);

        this.ui.windowMenu_div.css('background-color', this.model.attributes.AppFrame_BackGroundColor);

        this.ui.region001_1.css('background-color', this.model.attributes.Info_BackGroundColor);
        this.ui.region001_1.css('border-color', this.model.attributes.Info_ForeGroundColor);
        this.ui.region001_2.css('background-color', this.model.attributes.Info_BackGroundColor);
        this.ui.region001_2.css('border-color', this.model.attributes.Info_ForeGroundColor);
        this.ui.region001_3.css('background-color', this.model.attributes.Info_BackGroundColor);
        this.ui.region001_3.css('border-color', this.model.attributes.Info_ForeGroundColor);

        this.ui.hfont_01.css('font-family', this.model.attributes.Font1);
        this.ui.hfont_01.css('color', this.model.attributes.Font1_Color);
        this.ui.hfont_01.css('font-size', this.model.attributes.Font1_Size);
        this.ui.hfont_01.css('color', this.model.attributes.Font1_Color);

        this.ui.hfont_02.css('font-family', this.model.attributes.Info_Font1);
        this.ui.hfont_02.css('color', this.model.attributes.Info_Font1_Color);
        this.ui.hfont_02.css('font-size', '50px');
        this.ui.hfont_03.css('font-family', this.model.attributes.Info_Font2);
        this.ui.hfont_03.css('color', this.model.attributes.Info_Font2_Color);
        this.ui.hfont_03.css('font-size', '40px');
        this.ui.hfont_04.css('font-family', this.model.attributes.Info_Font3);
        this.ui.hfont_04.css('color', this.model.attributes.Info_Font3_Color);
        this.ui.hfont_04.css('font-size', '30px');

        this.ui.pfont_01.css('font-family', this.model.attributes.Font2);
        this.ui.pfont_01.css('color', this.model.attributes.Font2_Color);
        this.ui.pfont_01.css('font-size', this.model.attributes.Font2_Size);
        this.ui.pfont_02.css('font-family', this.model.attributes.Info_Font4);
        this.ui.pfont_02.css('color', this.model.attributes.Info_Font4_Color);
        this.ui.pfont_02.css('font-size', '20px');



        this.ui.e4us_maincolor_01.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor02_01.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor02_02.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor02_03.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor02_04.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor02_05.css('font-family', this.model.attributes.MenuColorApp_Font);

        this.ui.e4us_maincolor_02.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header01);

        this.ui.e4us_maincolor_01.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);
        this.ui.e4us_menucolor02_01.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);
        this.ui.e4us_menucolor02_02.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);
        this.ui.e4us_menucolor02_03.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);
        this.ui.e4us_menucolor02_04.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);
        this.ui.e4us_menucolor02_05.css('font-size', this.model.attributes.MenuColorApp_FontSize_Header02);

        this.ui.e4us_menucolor01_01.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_02.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_03.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_04.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_05.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_06.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_07.css('font-family', this.model.attributes.MenuColorApp_Font);
        this.ui.e4us_menucolor01_08.css('font-family', this.model.attributes.MenuColorApp_Font);


        this.ui.e4us_menucolor01_01.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_02.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_03.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_04.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_05.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_06.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_07.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);
        this.ui.e4us_menucolor01_08.css('font-size', this.model.attributes.MenuColorApp_FontSize_Footer);



        this.ui.e4us_menucolor02_01.hover(
            function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround02);
            }, function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround03);
            }
        );

        this.ui.e4us_menucolor02_02.hover(
            function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround02);
            }, function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround03);
            }
        );

        this.ui.e4us_menucolor02_03.css('background-color', this.model.attributes.MenuColorApp_BackGround);//'rgba(50,115,32,1)');
        this.ui.e4us_menucolor02_03.hover(
            function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround02);
            }, function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround03);
            }
        );

        this.ui.e4us_menucolor02_04.css('background-color', this.model.attributes.MenuColorApp_BackGround);//'rgba(50,115,32,1)');
        this.ui.e4us_menucolor02_04.hover(
            function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround02);
            }, function () {
                $(this).css('color', this.model.attributes.MenuColorApp_ForeGround03);
            }
        );
    },
    customEventThemeColorEditItem_btnSave_click: function (event) {
        var callback = function () {
        }

        this.save(callback);
    },
    customEventThemeColorEditItem_btnBack_click: function (event) {
        this.app.router.navigate("#customEventThemeColor?id=" + this.options.eventId);
        this.app.router.customEventThemeColor(this.options.eventId, this.options.scroll, 0);
    }
}, Backbone.Radio.Requests);


